(function ($) {
  "use strict";
  jQuery(document).ready(function () {
    // menu toggler js
    $("button.navbar-toggle").on('click', function () {
      $(".main-menu-area").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("ov-hidden");
    });
    $(".close-box").on('click', function () {
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("ov-hidden");
    });
    // filter button js
    $("button.filter-button").on('click', function () {
      $(".filter-sidebar").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
    });
    $("button.close-filter-sidebar").on('click', function () {
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
    });
    // body background color js
    $(".mm-fullscreen-bg").on('click', function () {
      $(".main-menu-area").removeClass("active");
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden");
    });
    $('.checkout-btn .read-agree').on('click', function () {
      if ($('.cust-checkbox').is(':checked')) {
        $('.checkout-btn button.check-btn').removeAttr('disabled');
      }
      else {
        $('.checkout-btn button.check-btn').attr('disabled', 'disabled');
      }
    });
    $('.read-agree').on('click', function () {
      if ($('.create-checkbox').is(':checked')) {
        $('.create').removeAttr('disabled');
      }
      else {
        $('.create').attr('disabled', 'disabled');
      }
    });
    $('.full-view, .zoom').on('click', function () {
      $('.product_img_top').magnificPopup({
        delegate: 'a',
        type: 'image',
        showCloseBtn: true,
        closeBtnInside: false,
        midClick: true,
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1]
        }
      }).magnificPopup('open');
    });
    $('.play-button, .popup-vimeo, .popup-gmaps').magnificPopup({
      tClose: 'Close (Esc)',
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });
    $('.item-data').on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).parents('.option-block').find(".variant-option").removeClass('active-variant');
      $(this).closest('form-wrap').addClass('active-variant');
      var it_img = $(this).attr('dataimg');

      // Only manually replace the image src if we are using the legacy single-image layout.
      // If the card uses .card-slider-group or .card-slider, product-card-slider.js handles switching.
      var $wrap = $(this).parents('.single-product-wrap');
      var hasSlider = $wrap.find('.card-slider').length > 0;
      var hasGroups = $wrap.find('.card-slider-group').length > 0;
      
      if (!hasSlider && !hasGroups) {
        $wrap.find('.product-image img').first().attr('src', it_img);
        $wrap.find('.product-image img').first().attr('srcset', it_img);
      }

      var price = $(this).attr('dataprice');
      var compareprice = $(this).attr('datacompare');
      var stocks = $(this).attr('dataavailable');
      $(this).parents('.single-product-wrap').find('.price-box .new-price').text(Shopify.formatMoney(price, window.money_format));
      if (compareprice > price) {
        $(this).parents('.single-product-wrap').find('.price-box .old-price').show();
        $(this).parents('.single-product-wrap').find('.price-box .old-price').html(Shopify.formatMoney(compareprice, window.money_format));
      } else {
        $(this).parents('.single-product-wrap').find('.price-box .old-price').hide();
      }
    });
    var drawerSliderEl = document.querySelector('.drawer-slider');
    if (drawerSliderEl) {
      var swiper = new Swiper('.drawer-slider', {
        slidesPerView: 1,
        grid: {
          rows: 1,
          fill: 'row',
        },
        spaceBetween: 30,
        navigation: {
          nextEl: '.arrow-next-drawer',
          prevEl: '.arrow-prev-drawer',
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        speed: 1000,
      });
    }
  });
})(jQuery);

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-slider').forEach(function (el) {
    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  });
});

function syncCartBadge() {
  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  return fetch(cartUrl + '?section_id=ajax-cart-icon', { cache: 'no-store' })
    .then(function (response) {
      return response.text();
    })
    .then(function (html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var badge = parsed.querySelector('.bigcounter');
      if (!badge) return;

      document.querySelectorAll('#ajax-cart-icon, #ajax-cart-icon-redesign').forEach(function (element) {
        var currentBadge = element.querySelector('.bigcounter');
        if (currentBadge) {
          currentBadge.innerHTML = badge.innerHTML;
        }
      });
    });
}

function syncCartPage() {
  var cartItems = document.querySelector('ajax-items');
  if (!cartItems) return Promise.resolve();

  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  return fetch(cartUrl + '?section_id=cart-section', { cache: 'no-store' })
    .then(function (response) {
      return response.text();
    })
    .then(function (html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var freshCartItems = parsed.querySelector('ajax-items');
      if (freshCartItems) {
        cartItems.innerHTML = freshCartItems.innerHTML;
        cartItems.className = freshCartItems.className;
      }
    });
}

function syncCartDrawer() {
  var cartDrawer = document.querySelector('ajax-cart');
  if (!cartDrawer) return Promise.resolve();

  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  return fetch(cartUrl + '?section_id=ajax-cart', { cache: 'no-store' })
    .then(function (response) {
      return response.text();
    })
    .then(function (html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var freshDrawer = parsed.querySelector('ajax-cart');
      var currentDrawer = cartDrawer.querySelector('#ajaxcart');
      var nextDrawer = freshDrawer && freshDrawer.querySelector('#ajaxcart');
      if (!freshDrawer || !currentDrawer || !nextDrawer) return;

      cartDrawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
      currentDrawer.innerHTML = nextDrawer.innerHTML;
    });
}

function syncCartAfterBfcacheRestore() {
  return Promise.allSettled([
    syncCartBadge(),
    syncCartPage(),
    syncCartDrawer()
  ]).catch(function () {
    // Keep the restored page usable even if cart re-sync fails.
  });
}

// Re-sync only cart UI after bfcache navigation instead of reloading the whole page.
window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    syncCartAfterBfcacheRestore();
  }
});
